/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum MediaType {
  Image = 'image',
  Video = 'video',
  Document = 'document'
}
